/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageFeeRetryResultDto
 */
export interface StorageFeeRetryResultDto {
    /**
     * 费用归属日期。
     * @type {string}
     * @memberof StorageFeeRetryResultDto
     */
    feeDate?: string;
    /**
     * 补跑类型。
     * @type {string}
     * @memberof StorageFeeRetryResultDto
     */
    retryType?: StorageFeeRetryResultDtoRetryTypeEnum;
    /**
     * 是否执行成功。
     * @type {boolean}
     * @memberof StorageFeeRetryResultDto
     */
    success?: boolean;
    /**
     * 失败原因，成功时为空。
     * @type {string}
     * @memberof StorageFeeRetryResultDto
     */
    errorMessage?: string;
}


/**
 * @export
 */
export const StorageFeeRetryResultDtoRetryTypeEnum = {
    ChinaStorage: 'CHINA_STORAGE',
    KoreaStorage: 'KOREA_STORAGE',
    OrangeFireStorage: 'ORANGE_FIRE_STORAGE'
} as const;
export type StorageFeeRetryResultDtoRetryTypeEnum = typeof StorageFeeRetryResultDtoRetryTypeEnum[keyof typeof StorageFeeRetryResultDtoRetryTypeEnum];


/**
 * Check if a given object implements the StorageFeeRetryResultDto interface.
 */
export function instanceOfStorageFeeRetryResultDto(value: object): value is StorageFeeRetryResultDto {
    return true;
}

export function StorageFeeRetryResultDtoFromJSON(json: any): StorageFeeRetryResultDto {
    return StorageFeeRetryResultDtoFromJSONTyped(json, false);
}

export function StorageFeeRetryResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageFeeRetryResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'feeDate': json['feeDate'] == null ? undefined : json['feeDate'],
        'retryType': json['retryType'] == null ? undefined : json['retryType'],
        'success': json['success'] == null ? undefined : json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function StorageFeeRetryResultDtoToJSON(json: any): StorageFeeRetryResultDto {
    return StorageFeeRetryResultDtoToJSONTyped(json, false);
}

export function StorageFeeRetryResultDtoToJSONTyped(value?: StorageFeeRetryResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feeDate': value['feeDate'],
        'retryType': value['retryType'],
        'success': value['success'],
        'errorMessage': value['errorMessage'],
    };
}

